class CountryManagerSingle {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
    }

    run() {
        document.querySelectorAll('[data-country-single]').forEach(el => {
            const mAddressFillForm = new CountryItem(el, this)
            mAddressFillForm.run()
        })
    }
}

class CountryItem {
    constructor(el, parent) {
        this.el = el
        this.parent = parent
    }

    run() {
        this.setCountrySelect(this.el.dataset.countrySingle)
        this.el.addEventListener('change', (ev) => {
            if (!(ev.target.matches('[data-country-item]'))) {
                return
            }
            this.update()
        })
        this.update()
    }

    setCountrySelect(key) {
        const element = this.el.querySelector('[data-country-item]')
        if (!element) {
            return;
        }
        if ('' !== element.value) {
            return;
        }
        element.value = key
    }

    getCountrySelect() {
        const element = this.el.querySelector('[data-country-item]')
        if (!element) {
            return ''
        }

        const option = element.querySelector('option:checked')
        if (!option) {
            return ''
        }

        return option.value
    }

    update() {
        const countrySelect = this.getCountrySelect()
        this.el.querySelectorAll('[data-country-phone]').forEach(el => {
            if (el.dataset.countryPhone && countrySelect == el.dataset.countryPhone) {
                el.style.display = 'block'
            } else {
                el.style.display = ''
            }
        })
    }
}

export default CountryManagerSingle